import { useEffect, useState } from 'react';
import { InAppContentDefinition, MESSAGE_FORMAT } from 'modules/graphql/types';
import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { FormField } from 'ui/formField';
import { CompatibilityTooltip } from '../CompatibilityTooltip';
import { SettingsReadOnlyText, CheckboxField } from '../../common';
import { getIsEditMode } from '../../common/utils';
import { SETTINGS_DISPLAY_CONTENT } from '../constants';
import { useQueryParamContext } from '../../context/QueryParamContext';

export const PresetAnimations = () => {
  const { view } = useQueryParamContext();
  const { isEditMode, liveTemplate, setCurrentMediumField } = useEditableFieldsContext();
  const isEditModeVisible = getIsEditMode(view, isEditMode);
  const inAppMediumData = (liveTemplate?.mediumData || {}) as InAppContentDefinition;
  const { inAppDisplaySettings, messageFormat } = inAppMediumData;
  const [isToggleActive, setIsToggleActive] = useState<boolean>(
    !!inAppDisplaySettings.shouldAnimate,
  );
  const handleSetToggle = () => {
    const newToggleStatus = !isToggleActive;
    setIsToggleActive(newToggleStatus);
    setCurrentMediumField('inAppDisplaySettings', {
      ...inAppDisplaySettings,
      shouldAnimate: newToggleStatus,
    });
  };

  /** Checkbox should display based on what the data says when toggle between edit/non-edit mode. */
  useEffect(() => {
    setIsToggleActive(!!inAppDisplaySettings.shouldAnimate);
  }, [isEditModeVisible]);

  return (
    <>
      {messageFormat !== MESSAGE_FORMAT.Json && (
        <FormField
          isHorizontalLayout
          labelText={SETTINGS_DISPLAY_CONTENT.presetAnimiations.labelText}
        >
          {isEditModeVisible ? (
            <CheckboxField
              label={
                <>
                  {SETTINGS_DISPLAY_CONTENT.presetAnimiations.compatibilityLabel}
                  <CompatibilityTooltip />
                </>
              }
              status={isToggleActive}
              onClick={handleSetToggle}
            />
          ) : (
            <SettingsReadOnlyText
              isUnset={!inAppDisplaySettings.shouldAnimate}
              data-test="preset-animation-ro"
            >
              {inAppDisplaySettings.shouldAnimate ? 'On' : 'Off'}
            </SettingsReadOnlyText>
          )}
        </FormField>
      )}
    </>
  );
};
